module.exports = __webpack_public_path__ + "img/22.c51212b4.png";